export default __webpack_public_path__ + "static/media/PauletteLovelace.d44b4aff.png";